export const NAVIGATE_FROM_HOST_WITH_URL_EVENT_ID = "navigate from host with URL";
